import { Col, Row } from "react-bootstrap";
import { useMediaQuery } from "@reactuses/core";
import { useTranslation } from "react-i18next";

const ExtensionSignUpMarketingPanel = () => {
  const { t } = useTranslation("auth");
  const smallHortizonalLayoutUpperVW = useMediaQuery("(max-width:1450px)");
  const smallHortizonalLayoutLowerVW = useMediaQuery("(min-width:1020px)");

  const shrinkText = smallHortizonalLayoutLowerVW && smallHortizonalLayoutUpperVW;
  return (
    <Row style={{ height: "100vh" }} className="d-flex align-items-center">
      <Col className="mx-auto ps-5" xs={12} md={8} xl={7}>
        <Row>
          <Col className={`text-center-xs text-start-lg fw-bold ${shrinkText ? "fs-3" : "fs-1"} mb-5`} xs={12}>
            {t(($) => $.auth.signup.extensionMarketing["Simply connect your store to our Chrome extension"])}
          </Col>
          <Col xs={12}>
            <ol className={`${shrinkText ? "fs-4" : "fs-2"} no-wrap fst-italic`} style={{ fontWeight: 500 }}>
              <li className="py-2"> {t(($) => $.auth.signup.extensionMarketing["Provide company information."])}</li>
              <li className="py-2">
                {t(($) => $.auth.signup.extensionMarketing["Connect your Amazon accounts (optional)."])}
              </li>
              <li className="py-2">
                {t(
                  ($) =>
                    $.auth.signup.extensionMarketing[
                      "Start using our extension on Amazon as you examine the competition."
                    ],
                )}
              </li>
            </ol>

            <hr
              style={{
                border: `1px solid #999`,
                background: "#ddd",
                margin: "2rem auto",
                textAlign: "center",
              }}
            />
            <p className={"text-center mt-4 fs-5"}>{t(($) => $.auth.signup["Trusted By"])} </p>
            <Row>
              <Col className="d-flex gap-3 logo_container align-items-center justify-content-center" xs={12}>
                <div className="logo"></div>
                <div className="logo"></div>
                <div className="logo"></div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ExtensionSignUpMarketingPanel;
